export default function StarIcon({rating}) {
    return(
        <div>
            <svg width="37.129" height="36.004" viewBox="0 0 37.129 36.004" style={rating ? {opacity: '30%'} : {}}>
                <path id="Icon_fa-solid-star" data-name="Icon fa-solid-star" d="M22.282,1.266a2.253,2.253,0,0,0-4.05,0l-4.521,9.3-10.1,1.491a2.25,2.25,0,0,0-1.252,3.825l7.327,7.249L7.959,33.377a2.256,2.256,0,0,0,3.284,2.363l9.021-4.816,9.021,4.816a2.256,2.256,0,0,0,3.284-2.363L30.832,23.133l7.327-7.249a2.25,2.25,0,0,0-1.252-3.825L26.8,10.568Z" transform="translate(-1.698)" fill="#72bf72"/>
            </svg>
        </div>
    )
}